import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fallback-cover__inner" }
const _hoisted_2 = { class: "fallback-cover__subtitle" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookFallbackCover',
  props: {
    title: {},
    subtitle: {}
  },
  setup(__props: any) {

const props = __props

// Colors that have good contrast with white text.
const darkColors = [
  '#418bfb',
  '#fe2d2d',
  '#3f5ed2',
  '#6c3fc9',
  '#ee1964',
  '#ff6b17',
  '#212121',
  '#96a1b0',
  '#4d3727',
  '#1b2c4a',
  '#b0ad89',
  '#dea882',
]

// Colors that need dark text to have sufficient contrast.
const lightColors = [
  '#ffc906',
  '#0ed1e3',
  '#65de51',
  '#d3bdb7',
  '#c0dee2',
  '#e5cb9a',
  '#c4b5bc',
]

const colors = [...darkColors, ...lightColors]

/**
 * Get a color for the background of the book cover.
 *
 * The color is picked randomly from the `colors` array
 * using the book title as a seed, so that it stays the same
 * between renders.
 */
const backgroundColor = computed(() => {
  const lowerCaseTitle = props.title.toLowerCase()

  let index = 0
  for (let i = 0; i < lowerCaseTitle.length; i++) {
    index += lowerCaseTitle.charCodeAt(i)
  }
  index = index % colors.length

  return colors[index]
})

/**
 * Return the modifier class for the text color.
 *
 * If the background color is light, we use black text.
 * If the background color is dark, we use white text.
 *
 * This assures we have good contrast between text and background.
 */
const textColorModifierClass = lightColors.includes(backgroundColor.value)
  ? 'fallback-cover--dark-text'
  : 'fallback-cover--light-text'

/**
 * Return the corresponding modifier class for the book title.
 *
 * For titles with long words, return a class modifier that reduces
 * the scale of the title, so that the word doesn't have to break or be
 * cut off.
 */
const titleSizeModifierClass = computed((): string | undefined => {
  const wordsInTitle = props.title.split(' ')
  // Find the longest word in the array
  const longestWord = wordsInTitle.reduce((a, b) => {
    return a.length > b.length ? a : b
  })

  if (longestWord.length > 16) {
    return 'fallback-cover__title--tiny'
  } else if (longestWord.length > 13) {
    return 'fallback-cover__title--smaller'
  } else if (longestWord.length > 9) {
    return 'fallback-cover__title--small'
  }

  return undefined
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fallback-cover", _unref(textColorModifierClass)]),
    style: _normalizeStyle({
      '--background-color': backgroundColor.value,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", {
        class: _normalizeClass(["fallback-cover__title", titleSizeModifierClass.value])
      }, _toDisplayString(__props.title), 3),
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.subtitle), 1)
    ])
  ], 6))
}
}

})